import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as typeMessages from '../../store/typeMessages'

import SVG from './pidPaez.svg'
import { select } from 'd3'

const indicators = {
  // temperature: {
  //   coor: [443, 345],
  //   unit: '°F',
  //   init: '00.0',
  //   shape: 'temperature' },
  pressure: {
    coor: [573, 165],
    unit: 'PSI',
    init: '00.00',
    shape: 'pressure',
    range: [0, 200] },
  volumen_total_day: {
    coor: [470, 180],
    unit: 'm³ today',
    init: '000.00',
    shape: 'pressure' }
  // cfflow: {
  //   coor: [445, 180],
  //   unit: 'MCF/H',
  //   init: '000.0',
  //   shape: 'cf',
  //   range: [-1, 100] }
}

const RED = '#f5222d'
const GREEN = '#a0d911'
// const ORANGE = '#faad14'
const BLUE = '#002b4c'
const GRAY = '#d9d9d9'

const setAlertSlunt = (shapes) => {
  let state = 0
  return setInterval(() => {
    let colors = [GREEN, RED]
    let color = colors[state ? 1 : 0]
    shapes.map(s => s.style('fill', color))
    state = !state
  }, 200)
}

class ProcessDiagram extends Component {
  constructor (props) {
    super(props)
    this.state = {
      alertSlunt: null,
      slunt1: { value: null, alert: false },
      slunt2: { value: null, alert: false },
      pressure: { value: null, alert: false },
      volumen_total_day: { value: null, alert: false }
      //  temperature: { value: null, alert: false }
    }
  }

  componentDidMount () {
    let svg = this.refs.svg.childNodes[0]
    this.svg = select(svg).style('width', '100%').style('height', 'auto')
    this.slunt1 = this.svg.select('path#nsai_slunt_1')
    this.slunt2 = this.svg.select('path#nsai_slunt_2')

    this.shapes = {
      cf: this.svg.select('path#nsai_cf'),
      temperature: this.svg.select('path#nsai_temperature'),
      pressure: this.svg.select('path#nsai_pressure')
    }

    this.text = {}
    for (let i in indicators) {
      this.text[i] = this.svg.append('text')
        .attr('x', indicators[i].coor[0])
        .attr('y', indicators[i].coor[1])
        .attr('text-anchor', 'middle')
        .text(`${indicators[i].init} ${indicators[i].unit}`)
        .attr('font-family', 'sans-serif')
        .attr('font-size', '1.2em')
        .attr('fill', GRAY)
    }

    this.componentWillReceiveProps(this.props)
  }

  componentWillReceiveProps (props) {
    let { slunt1, slunt2 } = props
    let newState = {}

    if (slunt1 !== this.state.slunt1.value || slunt2 !== this.state.slunt2.value) {
      if (slunt1 === 1 && slunt2 === 1) {
        newState = {
          ...newState,
          alertSlunt: setAlertSlunt([this.slunt1, this.slunt2]),
          slunt1: { value: slunt1, alert: true },
          slunt2: { value: slunt2, alert: true }
        }
      } else {
        newState = {
          ...newState,
          slunt1: { value: slunt1, alert: false },
          slunt2: { value: slunt2, alert: false }
        }
        if (this.alertSlunt !== null) {
          clearInterval(this.state.alertSlunt) // Remove alert
          newState = { ...newState, alertSlunt: null }
        }
      }
      this.slunt1.style('fill', slunt1 === 0 ? GREEN : BLUE)
      this.slunt2.style('fill', slunt2 === 0 ? GREEN : BLUE)
    }

    for (let i in indicators) {
      if (this.state[i].value === props[i]) continue
      this.text[i].text(`${props[i]} ${indicators[i].unit}`)
      this.text[i].transition()
        .attr('font-size', '1.4em')
        .duration(400)
        .transition()
        .attr('font-size', '1.2em')
        .duration(500)
      if (indicators[i].range) {
        let alert = indicators[i].range[0] > props[i] || indicators[i].range[1] < props[i]
        let color = alert ? RED : GREEN
        this.text[i].style('fill', color)
        this.shapes[indicators[i].shape].style('fill', color)
        newState = { ...newState, [i]: { value: props[i], alert } }
      } else {
        this.text[i].style('fill', '#555')
        this.shapes[indicators[i].shape].style('fill', GREEN)
        newState = { ...newState, [i]: { value: props[i], alert: false } }
      }
    }

    let { cfflow, cfpressure } = newState
    let cf = (cfflow && cfflow.alert) || (cfpressure && cfpressure.alert)
    let vl = (cfflow && cfflow.value) || (cfpressure && cfpressure.value)

    if (vl) this.shapes['cf'].style('fill', cf ? RED : GREEN)
    this.setState(newState)
  }

  shouldComponentUpdate () { return false }

  render () { return <div ref='svg'><SVG /></div> }
}

function mapStateToProps (state) {
  let { paez } = state.locations
  return {
    slunt1: paez.indicators.slunt1.lastValue,
    slunt2: paez.indicators.slunt2.lastValue,
    volumen_total_day: paez.indicators.volumen_total_day.lastValue,
    pressure: paez.indicators.pressure.lastValue
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(typeMessages, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ProcessDiagram)



// WEBPACK FOOTER //
// ./src/boards/paez/ProcessDiagram.js